export enum EPermissao {

    _ACESSO_GERAL = "0001",


    //###ADMIN
    ADMIN = "0043",

    //admin loja
    ADMIN_LOJA = "0068",
    ADMIN_LOJA_COMISSAO = "0066",
    ADMIN_LOJA_DESCONTO = "0069",
    ADMIN_LOJA_METASVENDA = "0067",
    ADMIN_LOJA_TARIFA = "0073",

    ADMIN_EMPRESAS = "0008",

    ADMIN_COLABORADORES = "0007",
    ADMIN_COLABORADORES_CONSULTAR = "0057",
    ADMIN_COLABORADORES_CADASTRAR = "0032",
    ADMIN_COLABORADORES_ALTERARSENHA = "0049",
    ADMIN_COLABORADORES_VINCULAR_EMPRESA = "0035",


    ADMIN_CADASTRO = "0048",

    ADMIN_CADASTRO_GRUPOPERMISSAO = "0047",

    ADMIN_CADASTRO_PLANOSEGURO = "0006",
    ADMIN_CADASTRO_PLANOSEGURO_CONSULTAR = "0058",
    ADMIN_CADASTRO_PLANOSEGURO_CADASTRAR = "0029",


    //###OPERAÇÃO
    OPERACAO = "0044",

    OPERACAO_VENDA = "0002",
    OPERACAO_VENDA_CONSULTAR_VENDA = "0059",
    OPERACAO_VENDA_REALIZAR_VENDA = "0010",
    OPERACAO_VENDA_ALTERAR_VENDA = "0011",
    OPERACAO_VENDA_CANCELAR_VENDA = "0012",

    OPERACAO_CLIENTE = "0005",
    OPERACAO_CLIENTE_CONSULTAR_CLIENTE = "0060",
    OPERACAO_CLIENTE_ALTERAR_CLIENTE = "0027",

    OPERACAO_SEGURO = "0003",
    OPERACAO_SEGURO_CONSULTAR_SEGURO = "0061",
    OPERACAO_SEGURO_REGISTRAR_SEGURO = "0016",
    OPERACAO_SEGURO_ALTERAR_SEGURO = "0017",
    OPERACAO_SEGURO_CANCELAR_SEGURO = "0018",

    OPERACAO_SINISTRO = "0004",
    OPERACAO_SINISTRO_CONSULTAR_SINISTRO = "0062",
    OPERACAO_SINISTRO_REGISTRAR_SINISTRO = "0021",
    OPERACAO_SINISTRO_ALTERAR_SINISTRO = "0022",
    OPERACAO_SINISTRO_REMOVER_SINISTRO = "0023",


    //###FINANCEIRO
    FINANCEIRO = "0045",

    FINANCEIRO_LANCAMENTO = "0009",
    FINANCEIRO_LANCAMENTO_CONSULTAR_LANCAMENTO = "0065",
    FINANCEIRO_LANCAMENTO_REGISTRAR_LANCAMENTO = "0037",
    FINANCEIRO_LANCAMENTO_ALTERAR_LANCAMENTO = "0038",
    FINANCEIRO_LANCAMENTO_CANCELAR_LANCAMENTO = "0039",
    FINANCEIRO_LANCAMENTO_REALIZAR_PAGAMENTO = "0040",
    FINANCEIRO_LANCAMENTO_REGISTRAR_DATARETROATIVA = "0041",
    FINANCEIRO_LANCAMENTO_ALTERAR_ANEXOS = "0050",


    //###RELATÓRIO
    RELATORIO = "0046",

    RELATORIO_COMISSAO = "0070",
    RELATORIO_COMISSAO_VISUALIZAR_RELATORIO = "0071",
    RELATORIO_COMISSAO_RECALCULAR_COMISSAO = "0072",

    RELATORIO_PRODUTOVENDIDO = "0051",

    RELATORIO_DRE_FORMAPAGAMENTO = "0052",

    RELATORIO_FECHAMENTOVENDEDOR = "0053",
    RELATORIO_FECHAMENTOVENDEDOR_VISUALIZAR_RELATORIO = "0063",
    RELATORIO_FECHAMENTOVENDEDOR_VISUALIZAR_VALORESCOLABORADORES = "0056",

    RELATORIO_RANKINGLOJA = "0054",
    RELATORIO_RANKINGLOJA_VISUALIZAR_RELATORIO = "0064",
    RELATORIO_RANKINGLOJA_VISUALIZAR_VALORESLOJAS = "0055",


    RELATORIO_METASVENDA = "0074",
    RELATORIO_METASVENDA_VISUALIZAR_RELATORIO = "0075",
    RELATORIO_METASVENDA_VISUALIZAR_VALORESLOJAS = "0076",

    RELATORIO_METASCOLABORADOR = "0077",

}

